/**
 * The pages every token job has, in the order the rail lists them. The rail's
 * tree and the jump palette read this list, so a token page added here (with
 * its route in src/router.tsx and its builder in lib/jobs `routes`) shows up
 * in both without further changes.
 */
import { routes } from "@/lib/jobs";

export interface TokenSection {
  /** the path segment after /t/:chain/:token ("" for the overview) */
  id: string;
  label: string;
  path: (chain: string, token: string) => string;
  /** carries the holders basis switch (?inherit_transfers=1) of the current token */
  keepsBasis?: boolean;
  /** extra words the jump palette matches */
  keywords?: string[];
}

export const TOKEN_SECTIONS: readonly TokenSection[] = [
  { id: "", label: "overview", path: routes.overview, keywords: ["home", "summary"] },
  { id: "tape", label: "tape", path: routes.tape, keywords: ["trades", "transfers"] },
  { id: "holders", label: "holders", path: routes.holders, keepsBasis: true, keywords: ["leaderboard"] },
  {
    id: "entry",
    label: "entry · supply · pnl",
    path: routes.entry,
    keepsBasis: true,
    keywords: ["entry", "supply", "pnl", "profit"],
  },
  { id: "flow", label: "flow", path: routes.flow, keywords: ["counterparties"] },
  {
    id: "liquidity",
    label: "liquidity",
    path: routes.liquidity,
    keywords: ["lp", "pools", "ranges", "depth"],
  },
];
